import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { Store } from '@ngrx/store';

import { AsyncPipe } from '@angular/common';
import { EnvironmentFeatures } from '@era/app';
import { Device, DeviceType } from '@era/locations-sdk';
import { DeviceStoreSelectors, LocationSubset } from '@era/stores';
import { EnvironmentService } from '@methylium/core';
import { NgbDropdownButtonItem, NgbDropdownItem, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContextMenuComponent } from '@rocksoft/cdk';
import { RebootDevicesModalContainerComponent } from '../../sub-features/reboot-devices-modal/reboot-devices-modal.container';
import { DeviceGridComponent } from '../device-grid/device-grid.component';
import { DevicesSyncModalContainerComponent } from '../devices-sync-modal/devices-sync-modal.container';

@Component({
  selector: 'era-devices-spare',
  templateUrl: './devices-spare.container.html',
  styleUrls: ['./devices-spare.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DeviceGridComponent, ContextMenuComponent, NgbDropdownButtonItem, NgbDropdownItem, AsyncPipe],
})
export class DevicesSpareContainerComponent {
  public readonly features: EnvironmentFeatures;
  public readonly spareDevices$: Observable<Device[]>;
  public readonly spareDevicesCount$: Observable<number>;

  constructor(
    private readonly deviceStore: Store<Device>,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly environmentService: EnvironmentService,
    private readonly modalService: NgbModal
  ) {
    this.features = this.environmentService.environment.features;
    this.spareDevices$ = this.deviceStore.select(DeviceStoreSelectors.selectCurrentLocationSpareDevices);

    this.spareDevicesCount$ = this.deviceStore.select(DeviceStoreSelectors.selectCurrentLocationSpareDevicesCount);
  }

  public itemSelected(device: Device) {
    if (device.deviceType === DeviceType.Apple) {
      void this.router.navigate(['apple', device.deviceId], { relativeTo: this.route });
    }
  }

  public openRebootRequest() {
    const modal = this.modalService.open(RebootDevicesModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = LocationSubset.Spare;
  }

  public openSyncModalRequest() {
    const modal = this.modalService.open(DevicesSyncModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = LocationSubset.Spare;
  }
}
